var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question"},_vm._l((_vm.message.options.responses),function(option,index){return _c('span',{key:index},[_c('button',{domProps:{"innerHTML":_vm._s(option.label)},on:{"click":function($event){return _vm.chooseResponse(option)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }